module.exports = __webpack_public_path__ + "img/supercashbing20261411.c4ed390a.jpg";